import src from "IMAGE";
export default { src, width: 1638, height: 744, blurWidth: 0, blurHeight: 0};
